import {
  z,
} from 'zod';

export const activityStatementRowSchema = z.object({
  month: z.string().optional(),
  v1A: z.string().optional(),
  v1B: z.string().optional(),
  v5A: z.string().optional(),
  v5B: z.string().optional(),
  vT1: z.string().optional(),
  vT4: z.string().optional(),
  vT5T7: z.string().optional(),
  vT6T9: z.string().optional(),
  vT8: z.string().optional(),
  vG1: z.string().optional(),
  vG2: z.string().optional(),
  vG3: z.string().optional(),
  vG10: z.string().optional(),
  vG11: z.string().optional(),
  vW1: z.string().optional(),
  vW2: z.string().optional(),
  vW3: z.string().optional(),
  vW4: z.string().optional(),
  vW5: z.string().optional(),
  vSUM: z.string().optional(),
});

export const activityStatementListSchema = z.object({
  rows: activityStatementRowSchema.array(),
  client_name: z.string(),
  abn: z.string().length(11),
}).array();

export type ActivityStatement = z.infer<typeof activityStatementListSchema>;
